export const RejectAccountIcon = ({ color = "#282828", size = 21, ...props }) => (
    <svg
        width={size}
        height={size * (16 / 21)}
        viewBox="0 0 21 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
    >
        <path
            d="M16.2935 2.42944H2.03261C1.05217 2.42944 0.258913 3.18148 0.258913 4.10064L0.25 14.1278C0.25 15.047 1.05217 15.799 2.03261 15.799H16.2935C17.2739 15.799 18.0761 15.047 18.0761 14.1278V4.10064C18.0761 3.18148 17.2739 2.42944 16.2935 2.42944ZM16.2935 14.1278H2.03261V5.77183L9.16304 9.94982L16.2935 5.77183V14.1278ZM9.16304 8.27863L2.03261 4.10064H16.2935L9.16304 8.27863Z"
            fill={color}
        />
        <circle cx="16.2934" cy="4.65745" r="4.45652" fill={color} />
        <path
            d="M18.5215 2.90763L18.0392 2.42923L16.3295 4.1252L14.6198 2.4292L14.1012 2.94357L15.8109 4.63957L14.0649 6.37134L14.5835 6.88572L16.3295 5.15394L17.9377 6.88569L18.42 6.40729L16.7755 4.63957L18.5215 2.90763Z"
            fill="white"
        />
    </svg>
);
